import { useVideoScreen } from "./videoFunction";

const VideoScreen = () => {
    const { showVideo, videoRef, videoLoop, videoIndex } = useVideoScreen();

    return (
        <div className={`${!showVideo ? 'hidden' : 'flex flex-row justify-center items-center h-screen'}`}>
            <video
                ref={videoRef}
                src={videoLoop[videoIndex]}
                autoPlay
                loop
                muted
                className="overflow-hidden w-full aspect-auto"
            />
        </div>
    );
};

export default VideoScreen;